import React from 'react';
import TopPerformingPostWidget from './TopPerformingPostWidget';

const TopPerformingPostWidgetBasic = () => (
  <TopPerformingPostWidget className="masonry-item w-[440px] h-[570px] flex flex-col" />
);

export default TopPerformingPostWidgetBasic;
